(function($) {
    class W4D_RangeFilter {
        constructor() {
            this.priceGap = 500;
            this.init();
        }

        init() {
            this.$rangeFilters = $(".range-filter");
            this.$rangeTriggers = $(".js-range-trigger");
            this.$rangeFilters.each((index, filter) => this.initializeFilter($(filter)));
            this.initializeTriggerToggle();
            this.initializeOutsideClick();
            this.checkUrlParamsAndUpdate();
        }

        initializeTriggerToggle() {
            this.$rangeTriggers.on("click", (e) => {
                const $trigger = $(e.currentTarget);
                const $rangeSelect = $trigger.closest(".range-select");

                // Check if parent has disabled class
                if ($rangeSelect.hasClass('range-select--disabled')) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }

                // Original functionality continues only if not disabled
                e.stopPropagation();
                if ($rangeSelect.length) {
                    $(".range-select.open").not($rangeSelect).removeClass("open");
                    $rangeSelect.toggleClass("open");
                }
            });

            $(".js-range-reset").on("click", () => {
                this.resetFilter();
                W4D_Pagination.fetchProducts();
            });
        }


        initializeOutsideClick() {
            $(document).on("click", (e) => {
                $(".range-select.open").each((index, openSelect) => {
                    if (!$(openSelect).has(e.target).length) {
                        $(openSelect).removeClass("open");
                    }
                });
            });
        }

        initializeFilter($filter) {
            const $rangeValue = $filter.find(".js-range-slider");
            const rangeInputs = {
                min: $filter.find(".js-min-range"),
                max: $filter.find(".js-max-range")
            };
            const priceInputs = {
                min: $filter.find(".js-min-input"),
                max: $filter.find(".js-max-input")
            };
            const visiblePriceInputs = {
                min: $filter.find(".js-min-input-visible"),
                max: $filter.find(".js-max-input-visible")
            };

            // Get initial values
            let minPrice = visiblePriceInputs.min.data('unformatted-value');
            let maxPrice = visiblePriceInputs.max.data('unformatted-value');

            // Set initial values for all inputs
            rangeInputs.min.val(minPrice);
            rangeInputs.max.val(maxPrice);
            priceInputs.min.val(minPrice);
            priceInputs.max.val(maxPrice);
            visiblePriceInputs.min.val(this.formatNumber(minPrice, true));
            visiblePriceInputs.max.val(this.formatNumber(maxPrice, true));

            visiblePriceInputs.min.on("blur", (e) => this.handleVisiblePriceInput(e, visiblePriceInputs, priceInputs, rangeInputs, $rangeValue));
            visiblePriceInputs.max.on("blur", (e) => this.handleVisiblePriceInput(e, visiblePriceInputs, priceInputs, rangeInputs, $rangeValue));

            $.each(rangeInputs, (key, $input) => {
                $input.on("input", (e) => this.handleRangeInput(e, priceInputs, visiblePriceInputs, rangeInputs, $rangeValue));
                $input.on("mouseup touchend", () => this.updateURLOnRelease(rangeInputs));
            });

            this.adjustPriceGap(maxPrice);
        }

        adjustPriceGap(maxPrice) {
            this.priceGap = Math.ceil(maxPrice * 0.02); // 2% of max Price
        }

        handleVisiblePriceInput(e, visiblePriceInputs, priceInputs, rangeInputs, $rangeValue) {
            let minPrice = parseFloat(this.removeCommas(visiblePriceInputs.min.val())) || 0;
            let maxPrice = parseFloat(this.removeCommas(visiblePriceInputs.max.val())) || 0;
            let priceGap = Math.ceil(maxPrice * 0.02);

            // Get the absolute min/max values from the range inputs
            const absoluteMin = parseInt(rangeInputs.min.attr('min')) || 0;
            const absoluteMax = parseInt(rangeInputs.max.attr('max')) || 10000;

            // Enforce absolute minimum
            if (minPrice < 0) {
                minPrice = absoluteMin;
                visiblePriceInputs.min.val(this.formatNumber(minPrice, true));
            }

            // Enforce absolute maximum
            if (maxPrice < 0 || maxPrice > absoluteMax) {
                maxPrice = absoluteMax;
                visiblePriceInputs.max.val(this.formatNumber(maxPrice, true));
            }

            if (minPrice > maxPrice - priceGap) {
                minPrice = maxPrice - priceGap;
                visiblePriceInputs.min.val(this.formatNumber(minPrice, true));
            }

            priceInputs.min.val(minPrice);
            priceInputs.max.val(maxPrice);
            rangeInputs.min.val(minPrice);
            rangeInputs.max.val(maxPrice);

            this.updateRange(minPrice, maxPrice, e.target, rangeInputs, $rangeValue);
            this.toggleSelectedClass(visiblePriceInputs.min.closest(".range-filter"), minPrice, maxPrice);
            this.updateURLWithPriceRange(minPrice, maxPrice);
        }

        handleRangeInput(e, priceInputs, visiblePriceInputs, rangeInputs, $rangeValue) {
            let minVal = parseInt(rangeInputs.min.val());
            let maxVal = parseInt(rangeInputs.max.val());
            if (maxVal - minVal < this.priceGap) {
                if (e.target === rangeInputs.min[0]) {
                    rangeInputs.min.val(maxVal - this.priceGap);
                } else {
                    rangeInputs.max.val(minVal + this.priceGap);
                }
            } else {
                this.updatePriceInputs(minVal, maxVal, priceInputs, visiblePriceInputs, rangeInputs, $rangeValue);
            }
        }

        updatePriceInputs(minVal, maxVal, priceInputs, visiblePriceInputs, rangeInputs, $rangeValue) {
            priceInputs.min.val(minVal);
            priceInputs.max.val(maxVal);
            visiblePriceInputs.min.val(this.formatNumber(minVal, true));
            visiblePriceInputs.max.val(this.formatNumber(maxVal, true));

            $rangeValue.css({
                left: `${(minVal / rangeInputs.min.attr('max')) * 100}%`,
                right: `${100 - (maxVal / rangeInputs.max.attr('max')) * 100}%`
            });

            const $filter = visiblePriceInputs.min.closest(".range-filter");
            this.toggleSelectedClass($filter, minVal, maxVal);
        }

        updateURLOnRelease(rangeInputs) {
            let minPrice = parseInt(rangeInputs.min.val());
            let maxPrice = parseInt(rangeInputs.max.val());
            this.updateURLWithPriceRange(minPrice, maxPrice);
        }

        updateURLWithPriceRange(minPrice, maxPrice) {
            const url = new URL(window.location.href);
            const priceRange = `${minPrice},${maxPrice}`;
            if (minPrice === 0 && maxPrice === 10000) {
                url.searchParams.delete('price');
            } else {
                url.searchParams.set('price', priceRange);
            }
            window.history.pushState({}, '', url.toString());
            W4D_Pagination.fetchProducts();
        }

        toggleSelectedClass($filter, minPrice, maxPrice) {
            const $rangeSelect = $filter.closest(".range-select");
            const $rangeTrigger = $rangeSelect.find(".js-range-trigger");
            if ($rangeSelect.length) {
                if (minPrice > 0 || maxPrice < 10000) {
                    $rangeSelect.addClass("selected");
                    let $priceInfoDiv = $rangeTrigger.find(".price-info");
                    if (!$priceInfoDiv.length) {
                        $priceInfoDiv = $("<div>", { class: "price-info" });
                        $rangeTrigger.append($priceInfoDiv);
                    }
                    $priceInfoDiv.text(`${this.formatNumber(minPrice, false)}-${this.formatNumber(maxPrice, true)}`);
                } else {
                    $rangeSelect.removeClass("selected");
                    const $priceInfoDiv = $rangeTrigger.find(".price-info");
                    if ($priceInfoDiv.length) $priceInfoDiv.remove();
                }
            }
        }

        removeCommas(value) {
            return parseInt(value.replace(' €', '').replace(/\./g, '') || 0);
        }

        formatNumber(number, includeEuro) {
            return number.toLocaleString('de-DE', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }) + (includeEuro ? ' €' : '');
        }

        resetFilter() {
            this.$rangeFilters.each((index, filter) => {
                const $filter = $(filter);
                const $rangeValue = $filter.find(".js-range-slider");
                const rangeInputs = {
                    min: $filter.find(".js-min-range"),
                    max: $filter.find(".js-max-range")
                };
                const priceInputs = {
                    min: $filter.find(".js-min-input"),
                    max: $filter.find(".js-max-input")
                };
                const visiblePriceInputs = {
                    min: $filter.find(".js-min-input-visible"),
                    max: $filter.find(".js-max-input-visible")
                };

                const defaultMin = parseInt(rangeInputs.min.attr('min'), 10);
                const defaultMax = parseInt(rangeInputs.max.attr('max'), 10);

                priceInputs.min.val(defaultMin);
                priceInputs.max.val(defaultMax);
                rangeInputs.min.val(defaultMin);
                rangeInputs.max.val(defaultMax);
                visiblePriceInputs.min.val(this.formatNumber(defaultMin, true));
                visiblePriceInputs.max.val(this.formatNumber(defaultMax, true));

                this.updateRange(defaultMin, defaultMax, null, rangeInputs, $rangeValue);

                // Remove the selected class from the range-select
                const rangeSelect = filter.closest(".range-select");
                if (rangeSelect) {
                    rangeSelect.classList.remove("selected");

                    // Remove price-info div from the trigger
                    const trigger = rangeSelect.querySelector(".js-range-trigger");
                    if (trigger) {
                        const priceInfoDiv = trigger.querySelector(".price-info");
                        if (priceInfoDiv) {
                            priceInfoDiv.remove();
                        }
                    }
                }

                $(rangeSelect).removeClass("open");
            });

            const url = new URL(window.location.href);
            url.searchParams.delete('price');
            window.history.pushState({}, '', url.toString());
        }

        updateRange(minVal, maxVal, target, rangeInputs, $rangeValue) {
            $rangeValue.css({
                left: `${(minVal / rangeInputs.min.attr('max')) * 100}%`,
                right: `${100 - (maxVal / rangeInputs.max.attr('max')) * 100}%`
            });
        }

        checkUrlParamsAndUpdate() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has("price")) {
                const [minPrice, maxPrice] = urlParams.get("price").split(",").map(price => parseInt(price, 10));
                this.$rangeFilters.each((index, filter) => {
                    const $filter = $(filter);
                    const rangeInputs = {
                        min: $filter.find(".js-min-range"),
                        max: $filter.find(".js-max-range")
                    };
                    const priceInputs = {
                        min: $filter.find(".js-min-input"),
                        max: $filter.find(".js-max-input")
                    };
                    const visiblePriceInputs = {
                        min: $filter.find(".js-min-input-visible"),
                        max: $filter.find(".js-max-input-visible")
                    };

                    priceInputs.min.val(minPrice);
                    priceInputs.max.val(maxPrice);
                    visiblePriceInputs.min.val(this.formatNumber(minPrice, true));
                    visiblePriceInputs.max.val(this.formatNumber(maxPrice, true));

                    rangeInputs.min.val(minPrice);
                    rangeInputs.max.val(maxPrice);

                    const $rangeValue = $filter.find(".js-range-slider");
                    this.updateRange(minPrice, maxPrice, null, rangeInputs, $rangeValue);
                    this.toggleSelectedClass($filter, minPrice, maxPrice);

                    // Only fetch products if price is the only parameter in URL
                    if (urlParams.toString().split('&').length === 1) {
                        W4D_Pagination.fetchProducts();
                    }
                });
            }
        }
    }

    $(document).ready(function() {
        window.W4D_RangeFilter = new W4D_RangeFilter();
    });
})(jQuery);